import React from "react";

import { Refine } from "@pankod/refine-core";
import {
    notificationProvider,
    Layout,
    ReadyPage,
    ErrorComponent, AntdLayout,
} from '@pankod/refine-antd';
import "@pankod/refine-antd/dist/reset.css";

import dataProvider from "@pankod/refine-simple-rest";
import routerProvider from "@pankod/refine-react-router-v6";
import {MonitorList} from './pages/monitor';
import {ColorModeContextProvider} from './contexts';
function App() {
  return (
      <ColorModeContextProvider>
    <Refine
      dataProvider={dataProvider("https://monitor.manxx.eu/api")}
      notificationProvider={notificationProvider}
      Layout={({ children, Footer, OffLayoutArea }) => (
          <AntdLayout>
              <AntdLayout.Content>
                  <AntdLayout.Content>
                      <div style={{ padding: 12, minHeight: window.innerHeight }}>
                          {children}
                      </div>
                  </AntdLayout.Content>
                  {Footer && <Footer />}
              </AntdLayout.Content>
              {OffLayoutArea && <OffLayoutArea />}
          </AntdLayout>
      )}
      ReadyPage={ReadyPage}
      catchAll={<ErrorComponent />}
      routerProvider={routerProvider}
      resources={[
        {
          name: 'monitor',
          list: MonitorList,
        }
      ]}
    />
      </ColorModeContextProvider>
  );
}

export default App;
